import Modal, {ModalProps} from './Modal';

function ControlsModal(props: ModalProps) {
    const { onClose } = props;

    return (
        <Modal onClose={onClose}>
            <div className="small">
                <div className="title">Controls</div>
                <div className="info">
                    Use the top toolbar to undo, redo, and pick templates.
                </div>
                <div className="info">
                    Use the bottom toolbar to modify terrain, scenery, atmosphere, and water.
                </div>
                <div className="info">
                    <b>Move Camera:</b> WASD or click-and-drag
                </div>
                <div className="info">
                    <b>Zoom Camera:</b> Q/E or Scroll
                </div>
                <div className="info">
                    <b>Undo / Redo:</b> Ctrl-Z / Ctrl-Y
                </div>
                <div className="info">
                    <b>+/- Brush Size:</b> Shift-Scroll
                </div>
                <div className="button" onClick={onClose}>Close</div>
            </div>
        </Modal>
    );
}

export default ControlsModal;
